import { useState, useCallback } from 'react';
import { RecentActivityFiltersState } from './RecentActivityFilters';

const DEFAULT_FILTERS: RecentActivityFiltersState = {
  search: '',
  sortBy: null,
  startDate: null,
  endDate: null,
};

export function useRecentActivityFilters() {
  const [filters, setFilters] = useState<RecentActivityFiltersState>(DEFAULT_FILTERS);

  const updateFilters = useCallback((newFilters: RecentActivityFiltersState) => {
    setFilters(newFilters);
  }, []);

  const resetFilters = useCallback(() => {
    setFilters(DEFAULT_FILTERS);
  }, []);

  const updateSearch = useCallback((search: string) => {
    setFilters(prev => ({ ...prev, search }));
  }, []);

  const updateSortBy = useCallback((sortBy: RecentActivityFiltersState['sortBy']) => {
    setFilters(prev => ({ ...prev, sortBy }));
  }, []);

  const updateDateRange = useCallback((startDate: Date | null, endDate: Date | null) => {
    setFilters(prev => ({ ...prev, startDate, endDate }));
  }, []);

  return {
    filters,
    updateFilters,
    resetFilters,
    updateSearch,
    updateSortBy,
    updateDateRange,
  };
}
